import React from "react";
import { ContentPlaceHolderPresetLineBlock } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var BannerPlaceholder = function BannerPlaceholder() {
  return ___EmotionJSX(ContentPlaceHolderPresetLineBlock, {
    width: "100%",
    height: "100px"
  });
};